define('shared/initializer/form/adapters/Member',[ 
    'shared/lib/ctor', 
    './Checkout', 
    './mixins/UpdateMemberInfoInMemberPage',
    './mixins/EmailRegistrationValidatable',
    './mixins/FixOnSuccessfulUrl',
    './mixins/MemberCreatable',
    './mixins/ClientIdTracking',
    './mixins/MemberFieldMapping',
    './mixins/InputValueRecoverable',
    './mixins/MemberCreationQuestionnaireBeforeCreatable',
    './mixins/MemberCreationQuestionnaireAfterCreatable',
    './mixins/fields/DynamicSubscribe',
    './mixins/fields/Email',
    './mixins/fields/PasswordLengthValidation',
    './mixins/EventLoadedEmittable',
    'shared/lib/RSVP'
], 
function ( 
    ctor, 
    Checkout, 
    UpdateMemberInfoInMemberPage,
    EmailRegistrationValidatable,
    FixOnSuccessfulUrl,
    MemberCreatable,
    ClientIdTracking,
    MemberFieldMapping,
    InputValueRecoverable,
    MemberCreationQuestionnaireBeforeCreatable,
    MemberCreationQuestionnaireAfterCreatable,
    DynamicSubscribeField,
    EmailField,
    PasswordLengthValidationField,
    EventLoadedEmittable,
    RSVP
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);

        me.mixin(
            EmailRegistrationValidatable,
            MemberFieldMapping,
            DynamicSubscribeField,
            EmailField,
            PasswordLengthValidationField,
            MemberCreationQuestionnaireBeforeCreatable,
            FixOnSuccessfulUrl,
            MemberCreatable,
            UpdateMemberInfoInMemberPage,
            ClientIdTracking,
            InputValueRecoverable,
            MemberCreationQuestionnaireAfterCreatable,
            EventLoadedEmittable
        );
    }).inherit(Checkout); 

    Ctor.prototype.doPageLoad = function () 
    {
        return RSVP.resolve();
    };

    return Ctor;
});
